import {
  FaClipboardList,
  FaGlobeAmericas,
  FaBookReader,
  FaChartLine,
  FaBookOpen,
  FaFeatherAlt,
} from "react-icons/fa";

const testSeriesData = [
  {
    id: "prelims-series",
    title: "Prelims Test Series",
    description: (
      <>
        Prepare strategically for UPSC Prelims with structured programs crafted
        for conceptual clarity and test performance. Choose{" "}
        <span className="font-semibold text-red-700">SANGAM</span> for
        chapter-wise mastery or{" "}
        <span className="font-semibold text-blue-800">KALAM</span> for yearly
        full-length mock practice.
      </>
    ),
    image:
      "https://ideogram.ai/assets/progressive-image/fast/response/4BngI7tMTkOxewH6ouLHCA",
    programs: [
      {
        name: "SANGAM: Chapter-Wise Expert Series",
        color: "red",
        icon: <FaClipboardList />,
        details: [
          "60+ Chapter-Level Tests",
          "Real-Time Answer Practice",
          "Coverage of All GS Papers",
          "Mini-Concept Notes Included",
        ],
      },
      {
        name: "KALAM: Yearly Prelims Test Series",
        color: "blue",
        icon: <FaGlobeAmericas />,
        details: [
          "50+ GS & CSAT Mocks",
          "All India Ranking System",
          "Trend-Based Questions",
          "Instant PDF + Scorecard",
        ],
      },
    ],
  },
  {
    id: "main-gs-series",
    title: "Main GS Test Series",
    description:
      "Strengthen your Mains preparation with structured programs designed for both long-term and fast-track aspirants.",
    image:
      "https://ideogram.ai/assets/progressive-image/fast/response/nIbuzyMuRq-5_lSk9r-stA",
    programs: [
      {
        name: "VIDYĀDHARA: 10-Month Intensive Program",
        color: "blue",
        icon: <FaBookReader />,
        details: [
          "GS I–IV & Essay coverage",
          "Sectional + full-length tests",
          "UPSC-standard evaluation",
          "Model answers & enrichment notes",
        ],
      },
      {
        name: "PRAGATI: Post-Prelims Focused Series",
        color: "red",
        icon: <FaChartLine />,
        details: [
          "Compact post-Prelims schedule",
          "GS I–IV & Essay practice",
          "Sectional + full-length papers",
        ],
      },
    ],
  },
  {
    id: "anthropology-series",
    title: "Anthropology Test Series",
    image:
      "https://ideogram.ai/assets/progressive-image/balanced/response/DWdiBkzTRoGCkU9-5dft0g",
    programs: [
      {
        name: "VIDYUT: Anthropology Program",
        color: "red",
        icon: <FaBookOpen />,
        details: [
          "5-month structured schedule",
          "Topic-wise sectional & full-length tests",
        ],
      },
      {
        name: "NEITHAL: Anthropology Series",
        color: "blue",
        icon: <FaFeatherAlt />,
        details: [
          "Short-term intensive schedule",
          "Sectional & full-length tests",
        ],
      },
    ],
  },
];

export default testSeriesData;
